import { useContext, useCallback } from 'react';
import { UserContext } from '../context/UserContext';

export const useCharacterUpdate = () => {
  const { updateCharacterStats, refreshCharacterStats } = useContext(UserContext);
  
  // Function to update stats after completing actions
  const updateAfterAction = useCallback((data) => {
    // Prevent rapid updates
    const now = Date.now();
    const lastUpdate = window._lastCharacterUpdate || 0;
    
    if (now - lastUpdate < 2000) { // 2 seconds minimum between updates
      console.log('Throttling character update - too frequent');
      return;
    }
    
    window._lastCharacterUpdate = now;
    
    // First, update with any immediate data we received
    if (data) {
      const statsToUpdate = {};
      
      // Handle the different ways stats might be returned from the API
      if (data.level !== undefined) statsToUpdate.level = data.level;
      if (data.gold !== undefined) statsToUpdate.gold = data.gold;
      if (data.good !== undefined && data.evil !== undefined) {
        statsToUpdate.alignment = data.good - data.evil;
      }
      if (data.alignment !== undefined) statsToUpdate.alignment = data.alignment;
      if (data.experience !== undefined) statsToUpdate.experience = data.experience;
      
      // Only update if there were changes
      if (Object.keys(statsToUpdate).length > 0) {
        updateCharacterStats(statsToUpdate);
      }
    }
    
    // Then, refresh from the API to ensure we have the latest data
    // Small delay to allow server to process any pending updates
    setTimeout(() => {
      refreshCharacterStats();
    }, 300);
  }, [updateCharacterStats, refreshCharacterStats]);
  
  return { updateAfterAction };
};